module.exports = __webpack_public_path__ + "img/icon-warning-rain-orange.850181ac.svg";